var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.9999C1.36839 11.0007 1.23793 10.9755 1.11609 10.9257C0.994256 10.8759 0.88344 10.8026 0.79 10.7099C0.696272 10.617 0.621877 10.5064 0.571109 10.3845C0.52034 10.2626 0.494202 10.1319 0.494202 9.99993C0.494202 9.86792 0.52034 9.73721 0.571109 9.61535C0.621877 9.49349 0.696272 9.38289 0.79 9.28993L4.1 5.99993L0.92 2.68993C0.733749 2.50257 0.629208 2.24911 0.629208 1.98493C0.629208 1.72074 0.733749 1.46729 0.92 1.27993C1.01296 1.1862 1.12356 1.11181 1.24542 1.06104C1.36728 1.01027 1.49799 0.984131 1.63 0.984131C1.76201 0.984131 1.89272 1.01027 2.01458 1.06104C2.13644 1.11181 2.24704 1.1862 2.34 1.27993L6.2 5.27993C6.38323 5.46686 6.48586 5.71818 6.48586 5.97993C6.48586 6.24168 6.38323 6.493 6.2 6.67993L2.2 10.6799C2.11024 10.7769 2.00217 10.855 1.88202 10.91C1.76187 10.9649 1.63203 10.9955 1.5 10.9999Z",
    fill: "#3671E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.00d7bb8656187bd94d42d36408419ee4.svg";
export { ForwardRef as ReactComponent };